import { PriorityHigh } from '@mui/icons-material';
import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import * as PATHS from '../config/paths';

export default function ErrorBoundaryPage() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <PriorityHigh color="error" sx={{ fontSize: 80 }} />
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
          }}
        >
          {t('ERROR_BOUNDARY_TITLE')}
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{ mt: 3 }}
          onClick={() => {
            // Force a full reload to clear any corrupted state
            window.location.href = PATHS.DASHBOARD_PATH;
          }}
        >
          {t('BACK_TO_HOME')}
        </Button>
      </Box>
    </Container>
  );
}
